<script setup lang="ts">
import { Form, Head } from '@inertiajs/vue3'

import AuthLayout from '@/layouts/AuthLayout.vue'
import { firstFormError } from '@/lib/forms'
import { identityPasswordResetPath } from '@/routes'

interface Props {
  sid: string
  email: string
}

const props = defineProps<Props>()
</script>

<template>
  <AuthLayout
    title="Reset password"
    description="Please enter your new password below"
  >
    <Head title="Reset password" />

    <Form
      v-slot="{ errors, processing }"
      method="put"
      :action="identityPasswordResetPath()"
      :transform="(data) => ({ ...data, sid, email })"
      :reset-on-success="['password', 'password_confirmation']"
    >
      <div class="grid gap-6">
        <UFormField
          label="Email"
          name="email"
          :error="firstFormError(errors.email)"
        >
          <UInput
            id="email"
            name="email"
            type="email"
            autocomplete="email"
            :default-value="props.email"
            icon="i-lucide-mail"
            class="w-full"
            readonly
          />
        </UFormField>

        <UFormField
          label="Password"
          name="password"
          :error="firstFormError(errors.password)"
        >
          <UInput
            id="password"
            name="password"
            type="password"
            autocomplete="new-password"
            autofocus
            placeholder="Password"
            icon="i-lucide-lock-keyhole"
            class="w-full"
          />
        </UFormField>

        <UFormField
          label="Confirm password"
          name="password_confirmation"
          :error="firstFormError(errors.password_confirmation)"
        >
          <UInput
            id="password_confirmation"
            name="password_confirmation"
            type="password"
            autocomplete="new-password"
            placeholder="Confirm password"
            icon="i-lucide-lock-keyhole"
            class="w-full"
          />
        </UFormField>

        <UButton
          type="submit"
          class="mt-4 w-full"
          :loading="processing"
          label="Reset password"
          icon="i-lucide-key-round"
        />
      </div>
    </Form>
  </AuthLayout>
</template>
